import React from "react";
import { useQuery } from "react-query";
import Loading from "../../Shared/Loading/Loading";
const ManagePublicDonors = () => {
  const publicDonorQueryURL = `${process.env.REACT_APP_apiHostLink}/api/v2/publicDonors`;
  const { isLoading, isError, data } = useQuery("ManagePublicDonor", () =>
    fetch(publicDonorQueryURL).then((res) => res.json())
  );

  // console.log(data);

  return (
    <div>
      <div className="text-center text-xl font-semibold">
        ManagePublicDonors
      </div>

      {isLoading && <Loading></Loading>}

      <div>
        <table>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Group</th>
              <th scope="col">District</th>
              <th scope="col">Number</th>
            </tr>
          </thead>

          <tbody>
            {data?.map((donor, index) => (
              <tr key={index}>
                <th scope="row">{donor?.name}</th>
                <td>{donor?.group}</td>
                <td>{donor?.district}</td>
                <td>{donor?.number}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManagePublicDonors;
